import { Renderer, Stave, StaveNote, Formatter, Accidental } from 'vexflow';

export function noteToVexKey(spec: string): string {
  const letter = spec[0].toLowerCase();
  const rest = spec.slice(1);
  const hasSharp = rest[0] === '#';
  const octave = hasSharp ? rest.slice(1) : rest;
  return `${letter}${hasSharp ? '#' : ''}/${octave}`;
}

export function renderNoteToElement(
  el: HTMLDivElement,
  spec: string,
  clef: 'treble' | 'bass',
): void {
  el.innerHTML = '';
  // Draw at VexFlow's native size (do NOT use context.scale — it prevents the
  // clef/note glyphs from painting). We enlarge for display afterwards via an
  // SVG viewBox, which scales the whole vector (staff + clef + note) uniformly.
  const W = 260;
  const H = 190;
  const renderer = new Renderer(el, Renderer.Backends.SVG);
  renderer.resize(W, H);
  const context = renderer.getContext();
  const stave = new Stave(0, 30, W - 14);
  stave.addClef(clef).setContext(context).draw();

  const key = noteToVexKey(spec);
  const note = new StaveNote({ keys: [key], duration: 'q', clef });
  if (key.includes('#')) note.addModifier(new Accidental('#'), 0);

  Formatter.FormatAndDraw(context, stave, [note]);

  // Enlarge for display without touching the draw coordinates: a viewBox plus
  // bigger width/height attributes scales the rendered vector up. The CSS in
  // MusicNotationRenderer keeps it responsive (max-width:100%).
  const svg = el.querySelector('svg');
  if (svg) {
    const displayW = 640;
    svg.setAttribute('viewBox', `0 0 ${W} ${H}`);
    svg.setAttribute('width', String(displayW));
    svg.setAttribute('height', String(Math.round((displayW * H) / W)));
  }
}
